import { getApiUrlString, setUrlMap } from '../modules/get_apiUrlString'
import { getCode }  from '../modules/get_code'

import roundCommonProcess from './process/roundCommonProcess'

console.log('api_thread_round.js')
const urlMap = {};

onmessage = async function(ev) {
  Object.assign(urlMap, ev.data);
  setUrlMap(urlMap);
  // console.log('urlMap', urlMap);

  const postData = await roundCommonProcess(ev.data);
  console.log(postData);
  if (postData.type == 'error') {
    postData.cb();
    return;
  }

  postData.tournament.forEach(schedule => {
    schedule.isCurrent = urlMap.queryObject.event_code == schedule.event_code;
    console.log(schedule, schedule.isCurrent);
  });
  const currentTournamentSchedule = postData.tournament.filter(schedule => schedule.isCurrent)[0];
  console.log(postData.tournament, currentTournamentSchedule);
  postData.page.eventCode = currentTournamentSchedule.event_code;

  // トーナメント（ラウンド）用データの取得
  const displayDailyScheduleInfo = postData.tournament.filter(hold_daily_schedule => urlMap.queryObject.event_code == hold_daily_schedule.event_code)[0];

  const raceQueryString = `?hold_daily_schedule_id_list[]=${displayDailyScheduleInfo.id}`;
  const raceResultPromise = await fetch(getApiUrlString("race_revision", raceQueryString))
    .then(res => res.json())
    .then(res => res.data[0])
    .then(res => {
      return res.race_list.map(raceInfo => {
        return {
          id: raceInfo.id,
          name: raceInfo.name,
          race_no: raceInfo.race_no,
          post_time: raceInfo.post_time,
          race_status: raceInfo.race_status,
          title: getCode('raceDetail', raceInfo.detail).name,
          isRaceDiscontinuation: raceInfo.cancel_status == 2,
          player_list: raceInfo.player_list
            .sort((a, b) => a.bike_no - b.bike_no)
            .map(contestant => {
              return {
                id: contestant.player.id,
                country_code: contestant.player.country_code,
                name: `${contestant.player.last_name_jp} ${contestant.player.first_name_jp}`
              }
            })
        };
      })
    });
  console.log('raceResultPromise', raceResultPromise);

  // 6レース分（1日に開催されるレース）のデータ構築
  const racePanelData = raceResultPromise.reduce((groupingRaceData, raceInfo) => {
      if (!groupingRaceData[raceInfo.name]) {
        groupingRaceData[raceInfo.name] = {
          title: getCode('race', raceInfo.name),
          races: []
        };
      }
      groupingRaceData[raceInfo.name].races.push(raceInfo);
      return groupingRaceData;
    }, {});
  Object.keys(racePanelData).forEach(key => {
    racePanelData[key].races.sort((a, b) => a.post_time.localeCompare(b.post_time))
  })

  // レース種目用データ構築
  const migratoryRaces = raceResultPromise.map(raceInfo => {
    // console.table(raceInfo);
    const { id, title, race_status, isRaceDiscontinuation, race_no } = raceInfo;
    return {
      id,
      title,
      isCurrent: id == urlMap.queryObject.race_id,
      isRaceComing: race_status == 1,
      isRaceDiscontinuation,
      num: `${race_no}R`
    }
  })

  postData.runDateInfo = convertDateInfo(displayDailyScheduleInfo);
  postData.racePanels = racePanelData;
  postData.migratoryRaces = migratoryRaces;

  // レースの開催可否
  postData.page.isAllRaceDiscontinuation = raceResultPromise.filter(raceInfo => raceInfo.isRaceDiscontinuation).length == raceResultPromise.length;
  // レース情報（出走表、出走順など）公開状況
  postData.page.isAllRaceComingSoon = raceResultPromise.filter(raceInfo => raceInfo.isRaceComing).length == raceResultPromise.length;

  // メインスレッドへのデータ返却
  postMessage(postData);
}

// レース詳細データの構築
const convertDateInfo = (dateInfo)  => {
  const dateObj = new Date(dateInfo.event_date);
  const weekMap = [
    '日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'
  ]
  return Object.assign({
    cls: dateInfo.day_night == 0 ? '_day' : '_night',
    zone: dateInfo.day_night == 0 ? 'デイ' : 'ナイト',
    date: dateInfo.event_date.split('-').slice(1).join('.'),
    week: weekMap[dateObj.getDay()]
  }, dateInfo)
}
